import { Component, OnInit, ViewEncapsulation, OnChanges, Input, SimpleChanges } from '@angular/core';
import { I18nService } from 'app/services/i18n/i18n.service';
import { Rest } from '../../../../rest/rest_client';
import { ServerValidatedFormComponent } from '../../../server-validated-form/server-validated-form.component';

@Component({
  selector: 'app-ecu-configuration-sc350m',
  templateUrl: './ecu-configuration-sc350m.component.html',
  styleUrls: ['./ecu-configuration-sc350m.component.css'],
})
export class EcuConfigurationSc350mComponent extends ServerValidatedFormComponent implements OnInit {
  
  @Input() ecuParameters: Rest.ECUConfigurationSC350M;
  

  modeOptions: any = [
    { label: "Disable ECU function", value: "DISABLE" },
    { label: "Enable ECU function", value: "ENABLE" },
  ];

  typeOptions: any = [
    { label: "None", value: "NONE" },
    { label: "Bosch (CAN-Bus)", value: "BOSCH" },
    { label: "Bafang (CAN-Bus)", value: "BAFANG" },
    { label: "Rhino2 (UART)", value: "RHINO2" },
  ];

  controlOptions: any = [
    { label: "None", value: "NONE" },
    { label: "cAN Command", value: "CAN" },
  ];

  batteryControlOptions: any = [
    { label: "None", value: "NONE" },
    { label: "RELAY1", value: "RELAY1" },
    { label: "CAN", value: "CAN" },
    { label: "RELAY2", value: "RELAY2" },
  ];

  lockOptions: any = [
    { label: "Disable the ECU Lock function", value: "DISABLE" },
    { label: "Enable the ECU Lock function", value: "ENABLE" },
  ];

  smartLampOptions: any = [
    { label: "Disable the Smart Lamp function", value: "DISABLE" },
    { label: "Enable the mart Lamp function", value: "ENABLE" },
  ];
  externalBatteryOptions: any = [
    { label: "Disable", value: "DISABLE" },
    { label: "External battery on, turn off it after SC350M battery fully charged", value: "EXTERNAL_BATTERY_ON_TURN_OFF" },
    { label: "External battery on, keep it on when SC350M battery fully charged", value: "EXTERNAL_BATTERY_ON_KEEP" },
    { label: "Turn ECU on, turn off it after SC350M battery is fully charged", value: "ECU_ON_TURN_OFF" },
    { label: "Turn ECU on, keep it on when SC350M battery is fully charged", value: "ECU_ON_KEEP" },
    { label: "Turn external battery & ECU on, turn off them after SC350M battery is fully charged", value: "EXTERNAL_BATTERY_ECU_ON_TURN_OFF" },
    { label: "Turn external battery & ECU on, keep them on when SC350M battery is fully charged", value: "EXTERNAL_BATTERY_ECU_ON_KEEP" },
  ];

  constructor(protected i18n: I18nService) { super(i18n); }
  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges){
    if (changes["deviceParams"]) {
      console.log("arrive deviceParams", this.ecuParameters);
    }
  }

}
